module.exports = __webpack_public_path__ + "static/media/trash-disabled.d6a9fbc9.svg";